module.exports = __webpack_public_path__ + "static/media/30.bb4327cf.jpg";